import styles from "./Section.module.scss"
import cx from "classnames"
import Link from "../Link"

const Section = ({
  teaser,
  headline,
  subline,
  text,
  links,
  className,
  children,
}) => {
  return (
    <section className={cx(styles.section, className)}>
      {(teaser || headline || subline || text || links?.length > 0) && (
        <div className={styles.sectionContent}>
          <header>
            {teaser && (
              <div
                className={styles.sectionTeaser}
                dangerouslySetInnerHTML={{ __html: teaser }}
              />
            )}
            {headline && (
              <h2
                className={styles.sectionHeadline}
                dangerouslySetInnerHTML={{ __html: headline }}
              />
            )}
            {subline && (
              <div
                className={styles.sectionSubline}
                dangerouslySetInnerHTML={{ __html: subline }}
              />
            )}
            {text && (
              <div
                className={styles.sectionText}
                dangerouslySetInnerHTML={{ __html: text }}
              />
            )}
            {links?.length > 0 && (
              <div className={styles.links}>
                {links.map((link, i) => (
                  <Link key={i} link={link} />
                ))}
              </div>
            )}
          </header>
        </div>
      )}

      {children}
    </section>
  )
}

export default Section
